module.exports = __webpack_public_path__ + "img/uva-logo.a1783fba.svg";